module.exports = __webpack_public_path__ + "img/sld_vcb_red_ta1_ba1.140cd33b.svg";